import { ErrorBoundary } from '@components/error-boundary';
import { ModulesEnum } from '@/types/enums/filials';
import { useAppSelector } from '@/hooks/redux/redux';
import CommonModuleContainer from '@/containers/pages/filials/edit/components/common/modules';

const CalendarModule = () => {
  const { filial } = useAppSelector((state) => state.filials);

  return (
    <ErrorBoundary componentTitle="Calendar module page">
      <CommonModuleContainer filial={filial} currentModule={ModulesEnum.Calendar} />
    </ErrorBoundary>
  );
};

export default CalendarModule;
